export const FUNCTION_BLOCK_LABEL = "func_block"; //name for the block that holds entire body of each function. Used for implementing return statements.
